var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiever(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 17.419,
    viewBox: "0 0 60 17.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.42h60V0H0zm58.691-1.313H1.31V1.312H58.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.23 5.177h1.34v7.062h-1.34zm5.484.007h4.468v1.28h-4.468zm0 2.683h3.902v1.281h-3.902zm0 3.087h4.468v1.282h-4.468zm18.783-5.77h4.469v1.28h-4.47zm0 2.683h3.902v1.281h-3.902zm0 3.087h4.469v1.282h-4.47zM8.347 6.49h2.162V5.177H7.014v7.065h1.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21 7.853h1.295v1.302H9.21zm23.059 4.348l-3.146-6.983h1.54l1.817 3.965 1.806-3.965h1.536l-3.135 6.983zm19.329-2.98a2.098 2.098 0 001.23-1.914c0-1.163-.94-2.116-2.097-2.116h-2.638v7.027h1.398V6.596h1.24c.39 0 .698.321.698.711 0 .39-.311.702-.698.702h-.532V9.43l1.299 2.798h1.488z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiever);
export default __webpack_public_path__ + "static/media/fiever.6646ce9a41e32da7a76578df683691d5.svg";
export { ForwardRef as ReactComponent };